import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import './include/bootstrap'
import { BrowserRouter } from 'react-router-dom';
import Conteudo from './Conteudo';

ReactDOM.render(
    <BrowserRouter>
        <App />
        <Conteudo/>
    </BrowserRouter>,
    document.getElementById('root'));
